import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { authSelectors } from "../../redux/auth";
import Trans from "../intl/Trans";
import PrivateLayout from "../app/Layout/PrivateLayout";
import PublicLayout from "../app/Layout/PublicLayout";
import PrivatePage from "../app/Page/PrivatePage";
import routes from "../router/routes";
import Link from "../../vendor/router/Link";
import Error404Icon from "../../../resources/images/icons/Error404Icon.png";
NotFoundErrorPage.propTypes = {};
/**
 * This page is rendered as a standalone page when the router doesn't match a router
 * but also by the InternalServerErrorPage. when the app fails with a ReactRouterLoader error
 * and the error has a status (or a response.status) code of 404.
 */ export default function NotFoundErrorPage() {
    /**
     * --------------------
     * Get the identity in order to ensure we can link to the dashboard or login
     * --------------------
     */ var hasIdentity = useSelector(authSelectors.hasIdentity);
    var emailIsVerified = useSelector(authSelectors.emailIsVerified);
    /**
     * --------------------
     * Get the translator for the page title
     * --------------------
     */ var t = useTranslation().t;
    var Layout = hasIdentity && emailIsVerified ? PrivateLayout : PublicLayout;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(PrivatePage, {
        title: t("common.errors.pages.not-found.page-title")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-[calc(100vh-180px)] flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8"
    }, /*#__PURE__*/ React.createElement("img", {
        src: Error404Icon,
        alt: "Not found error icon",
        className: "mx-auto mb-8 h-56 w-56 sm:mb-12 sm:h-72 sm:w-72"
    }), /*#__PURE__*/ React.createElement("h1", {
        className: "mb-6 mt-4 text-2xl font-bold dark:text-white"
    }, /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.not-found.title")), /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-600 dark:text-gray-400"
    }, /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.not-found.subtitle")), /*#__PURE__*/ React.createElement("div", {
        className: "mt-5 flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-3"
    }, hasIdentity && emailIsVerified && /*#__PURE__*/ React.createElement(Link, {
        to: routes.DASHBOARD,
        className: "inline-flex w-full items-center justify-center gap-2 rounded-md border border-transparent px-4 py-3 text-sm font-semibold text-blue-500 ring-offset-white transition-all hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:ring-offset-slate-900 sm:w-auto"
    }, /*#__PURE__*/ React.createElement("svg", {
        className: "h-2.5 w-2.5",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11.2792 1.64001L5.63273 7.28646C5.43747 7.48172 5.43747 7.79831 5.63273 7.99357L11.2792 13.64",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    })), /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.not-found.back-btn.private")), !hasIdentity && /*#__PURE__*/ React.createElement(Link, {
        to: routes.AUTH_LOGIN,
        className: "inline-flex w-full items-center justify-center gap-2 rounded-md border border-transparent px-4 py-3 text-sm font-semibold text-blue-500 ring-offset-white transition-all hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:ring-offset-slate-900 sm:w-auto"
    }, /*#__PURE__*/ React.createElement("svg", {
        className: "h-2.5 w-2.5",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11.2792 1.64001L5.63273 7.28646C5.43747 7.48172 5.43747 7.79831 5.63273 7.99357L11.2792 13.64",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    })), /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.not-found.back-btn.public"))))));
}
